// import "./list.scss"
import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Datatable from "../../components/datatable/Datatable";
import SendEmailService from "../../services/sendEmail";
import SendSmsService from "../../services/sendSms";
import { Link } from "react-router-dom";
import Toast from "../../components/toast/Toast";
import columnsHeaderEmail from "./ColumnsHeaderDataEmail";
import columnsHeaderSms from "./ColumnsHeaderDataSMS";
import Loader from "../../components/spinner/Spinner";
import Backdrop from "../../components/backdrop/Backdrop";
import SendEmailModal from "./SendEmailModal";
import SendSmsModal from "./SendSmsModal";
import { Box, Tab, Tabs } from "@mui/material";
import {
  AdminTabPanel,
  adminTabA11yProps,
} from "../../components/tabPanel/AdminTabPanel";

const SendEmail = () => {
  const [rowData, setRowData] = useState([]);
  const [rowDataSms, setRowDataSms] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [backdrop, setBackdrop] = useState(false);
  const [isSidebar, setIsSidebar] = useState(null);
  const [openSmsModal, setOpenSmsModal] = useState(false);
  const [valueTabs, setValueTabs] = useState(0);

  const handleChangeTabs = (e, newValue) => {
    setValueTabs(newValue);
  };

  useEffect(() => {
    getAllEmails();
    getAllSms();
  }, []);

  const getAllEmails = async () => {
    setLoading(true);
    try {
      let { data } = await SendEmailService.fetchEmails();
      setRowData(data.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getAllSms = async () => {
    setLoading(true);
    try {
      let { data } = await SendSmsService.fetchSms();
      setRowDataSms(data.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const onSubmit = async (values) => {
    setBackdrop(true);
    try {
      await SendEmailService.addEmail(values);
      setToastOpen(true);
      setToastMsg(`Email sent successfully`);
      setToastStatus("success");
      setOpen(false);
      getAllEmails();
      setSelectedRow({});
      setBackdrop(false);
    } catch (err) {
      console.log(err);
      setToastOpen(true);
      setBackdrop(false);
      setToastStatus("error");
      setToastMsg("Something went wrong!");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete the record?")) return;
    setBackdrop(true);
    try {
      await SendEmailService.deleteEmail(id);
      setToastOpen(true);
      setToastMsg("Email deleted successfully");
      setToastStatus("success");
      setOpen(false);
      getAllEmails();
      setBackdrop(false);
    } catch (err) {
      setBackdrop(false);
      console.log(err);
    }
  };

  const handleDeleteSms = async (id) => {
    if (!window.confirm("Are you sure to delete the record?")) return;
    setBackdrop(true);
    try {
      await SendSmsService.deleteSms(id);
      setToastOpen(true);
      setToastMsg("SMS deleted successfully");
      setToastStatus("success");
      setOpen(false);
      getAllSms();
      setBackdrop(false);
    } catch (err) {
      setBackdrop(false);
      console.log(err);
    }
  };

  const onSubmitSms = async (values) => {
    setBackdrop(true);
    try {
      await SendSmsService.sendSms(values);
      setToastOpen(true);
      setToastMsg(`SMS sent successfully`);
      setToastStatus("success");
      setOpen(false);
      getAllSms();
      setSelectedRow({});
      setBackdrop(false);
    } catch (err) {
      console.log(err);
      setToastOpen(true);
      setBackdrop(false);
      setToastStatus("error");
      setToastMsg("Something went wrong!");
    }
  };

  return (
    <div className="list">
      <Sidebar isSidebar={isSidebar} />
      <div className="listContainer">
        <Navbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        {loading ? (
          <Loader />
        ) : (
          <>
            <Box
              className="email-sms-tabs-bar"
              sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}
            >
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="Email and SMS history"
                variant="standard"
                centered
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 600,
                  },
                }}
              >
                <Tab label="Send Email" {...adminTabA11yProps(0)} />
                <Tab label="Send SMS" {...adminTabA11yProps(1)} />
              </Tabs>
            </Box>

            <AdminTabPanel value={valueTabs} index={0}>
              <Datatable
                pageTitle={"Sent Email"}
                columnsData={columnsHeaderEmail.columnsData}
                actionColumn={columnsHeaderEmail.actionHeader(
                  handleDelete,
                  setOpen,
                  setSelectedRow,
                )}
                rowData={rowData}
                addBtnTxt={"Send Email"}
                onAddBtn={() => {
                  setOpen(true);
                  setSelectedRow({});
                }}
              />
            </AdminTabPanel>

            <AdminTabPanel value={valueTabs} index={1}>
              <Datatable
                pageTitle={"Sent SMS"}
                columnsData={columnsHeaderSms.columnsData}
                actionColumn={columnsHeaderSms.actionHeader(
                  handleDeleteSms,
                  setOpenSmsModal,
                  setSelectedRow,
                )}
                rowData={rowDataSms}
                addBtnTxt={"Send SMS"}
                onAddBtn={() => {
                  setOpenSmsModal(true);
                  setSelectedRow({});
                }}
              />
            </AdminTabPanel>
          </>
        )}

        {open && (
          <SendEmailModal
            onSubmit={onSubmit}
            open={open}
            onClose={() => setOpen(false)}
          />
        )}

        {openSmsModal && (
          <SendSmsModal
            onSubmit={onSubmitSms}
            open={openSmsModal}
            onClose={() => setOpenSmsModal(false)}
          />
        )}
      </div>
      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
      {backdrop && <Backdrop />}
    </div>
  );
};

export default SendEmail;
